<template>
  <div class="weui-flex__item">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'FlexItem',
  data() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/flex-item/flex-item.vue